/**
 * Shared constants and deterministic PRNG for the Endless Palace.
 * Standalone module (no three.js, no imports) so every palace file can use it
 * without cycles.
 */

export const PALACE = {
  WALL_H: 6.5, // default room wall height
  WALL_T: 0.45, // wall thickness (each room owns its own four walls)
  DOOR_W: 2.6,
  DOOR_H: 3.6,
  EYE: 1.62, // hanging eye line
  RAIL: 3.05, // picture rail: nothing hangs above it, in any room
  ROTUNDA_R: 8,
  WALL_OFF: 0.06, // canvases float this far off the wall face
  GUTTER: 0.16, // uniform gap inside an organic cluster hang
  SEG_MARGIN: 0.6, // dead margin at the ends of each hangable segment
  HANG_LO: 0.75, // bottom of the hang band
  CLEARANCE: 0.45, // minimum air gap between unrelated room footprints
};

// Sides of a room footprint. N = +z edge, S = -z, E = +x, W = -x.
// `left`/`right` are relative to an observer travelling *toward* that side.
export const SIDES = {
  N: { dx: 0, dz: 1, opp: 'S', left: 'W', right: 'E' },
  S: { dx: 0, dz: -1, opp: 'N', left: 'E', right: 'W' },
  E: { dx: 1, dz: 0, opp: 'W', left: 'N', right: 'S' },
  W: { dx: -1, dz: 0, opp: 'E', left: 'S', right: 'N' },
};

export const mulberry32 = (seed) => () => {
  seed |= 0;
  seed = (seed + 0x6d2b79f5) | 0;
  let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
  t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
};

export const hashString = (s) => {
  let h = 5381;
  for (let i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0;
  return h;
};

export const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
